import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { useCallback, useState } from "react";

const UndoMeetingPrepCardHideMutation = graphql(`
  mutation UndoMeetingPrepCardHide($id: ID!) {
    undoMeetingPrepCardHide(id: $id) {
      id
      __typename
      clientId
      prepSessionId
      cardKey
      cardType
      reason
      status
      endedAt
    }
  }
`);

export function useUndoMeetingPrepCardHide() {
  const [result, undoMeetingPrepCardHideMutation] = useMutation(UndoMeetingPrepCardHideMutation);
  const [error, setError] = useState<Error | null>(null);

  const undoMeetingPrepCardHide = useCallback(
    async (id: string) => {
      try {
        const response = await undoMeetingPrepCardHideMutation({ id });
        if (response.error) {
          throw response.error;
        }
        setError(null);
        return response.data?.undoMeetingPrepCardHide;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [undoMeetingPrepCardHideMutation],
  );

  return { undoMeetingPrepCardHide, result, error };
}
